import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';

import LoginAdmin from './pages/LoginAdmin';
import LoginVereador from './pages/LoginVereador';
import LoginAdminSlug from './pages/LoginAdminSlug';
import LoginVereadorSlug from './pages/LoginVereadorSlug';
import LoginOperador from './pages/LoginOperador';
import Dashboard from './pages/Dashboard';
import Vereadores from './pages/Vereadores';
import Sessoes from './pages/Sessoes';
import SessaoDetalhe from './pages/SessaoDetalhe';
import PainelVereador from './pages/PainelVereador';
import PainelOperador from './pages/PainelOperador';
import PainelTV from './pages/PainelTV';
import Relatorios from './pages/Relatorios';
import Camaras from './pages/Camaras';
import Logs from './pages/Logs';
import Protocolos from './pages/Protocolos';
import Projetos from './pages/Projetos'; // ← NOVO
import Comissoes from './pages/Comissoes'; // PLENARIUM:COMISSOES
import CentralDocumentos from './components/CentralDocumentos'; // PLENARIUM:CENTRAL_DOCUMENTOS
import CentralAtas from './pages/CentralAtas'; // PLENARIUM:CENTRAL_ATAS
import RecuperarSenha from './pages/RecuperarSenha';
import RedefinirSenha from './pages/RedefinirSenha';
import Layout from './components/Layout';

const RotaProtegida = ({ children, role, superAdmin }) => {
  const { usuario, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!usuario) return <Navigate to="/login/admin" replace />;
  if (role && usuario.role !== role) return <Navigate to="/" replace />;
  if (superAdmin && !usuario.superAdmin) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          {/* Rotas por câmara (slug) — completamente isoladas */}
          <Route path="/camara/:slug/login/vereador" element={<LoginVereadorSlug />} />
          <Route path="/camara/:slug/login/admin" element={<LoginAdminSlug />} />
          <Route path="/camara/:slug/tv/:sessaoId" element={<PainelTV />} />

          {/* Públicas */}
          <Route path="/login/admin" element={<LoginAdmin />} />
          <Route path="/login/vereador" element={<LoginVereador />} />
          <Route path="/login/operador" element={<LoginOperador />} />
          <Route path="/tv/:sessaoId" element={<PainelTV />} />
          <Route path="/recuperar-senha" element={<RecuperarSenha />} />
          <Route path="/redefinir-senha" element={<RedefinirSenha />} />

          {/* Vereador */}
          <Route path="/vereador" element={<RotaProtegida role="vereador"><PainelVereador /></RotaProtegida>} />

          {/* Operador de Protocolo */}
          <Route path="/operador" element={<RotaProtegida role="operador"><PainelOperador /></RotaProtegida>} />

          {/* Admin */}
          <Route path="/" element={<RotaProtegida role="admin"><Layout /></RotaProtegida>}>
            <Route index element={<Dashboard />} />
            <Route path="vereadores" element={<Vereadores />} />
            <Route path="sessoes" element={<Sessoes />} />
            <Route path="sessoes/:id" element={<SessaoDetalhe />} />
            <Route path="relatorios" element={<Relatorios />} />
            <Route path="protocolos" element={<Protocolos />} />
            <Route path="projetos" element={<Projetos />} /> {/* ← NOVO */}
            <Route path="comissoes" element={<Comissoes />} /> {/* PLENARIUM:COMISSOES */}
            <Route path="documentos" element={<CentralDocumentos modo="admin" />} /> {/* PLENARIUM:CENTRAL_DOCUMENTOS */}
            <Route path="atas" element={<CentralAtas />} /> {/* PLENARIUM:CENTRAL_ATAS */}
            <Route path="camaras" element={<RotaProtegida superAdmin={true}><Camaras /></RotaProtegida>} />
            <Route path="logs" element={<Logs />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;